<script setup lang="ts">
import { LINKS } from "@/constants/links";
</script>

<template>
    <div class="row mb-3">
        <div class="col-xl-6">
            <div class="float-left border-radius-ar p-4 bg-white">
                <p class="font-weight-bold">
                    To search the whole market and see if we can find you a better annuity income
                    than your current pension provider, we’ll need:
                </p>
                <ul class="float-left mt-1 begin-li">
                    <li>Your pension details including current value so we can provide accurate quotes.</li>
                    <li>
                        Your health and lifestyle information.
                        You could receive a higher income if you have certain medical
                        conditions and/or are overweight, or smoke.
                    </li>
                </ul>
                <p class="font-weight-bold">
                    Please remember:
                </p>
                <ul class="begin-li pt-1">
                    <li>Annuity rates and pension funds can go down as well as up.</li>
                    <li>Your quote's annuity rate is guaranteed by the annuity provider for a limited time.</li>
                </ul>
            </div>
        </div>
        <div class="col-xl-6 mt-4 mt-xl-0">
            <div class="font-smaller float-left border-radius-ar p-4 bg-intro-right ml-xl-3">
                <p>
                    Please tell us if there are any personal circumstances we may need to consider during your quote
                    and/or
                    application. You can call us free on <a href="tel:08003265479">0800 326 5479</a> or email <a
                        href="mailto:hello@annuityready.com"
                    >hello@annuityready.com</a>
                </p>
                <p class="font-weight-bold pt-1">
                    Please read:
                </p>
                <p>
                    <ul class="begin-li">
                        <li>
                            Our <a
                                class="font-weight-bold"
                                target="_blank"
                                :href="LINKS.ANNUITY_PRIVACY_NOTICE_DOCUMENT_LINK"
                            >Privacy Notice</a> - to see how we use your
                            information.
                        </li>
                        <li>
                            Our <a
                                class="font-weight-bold"
                                target="_blank"
                                :href="LINKS.OUR_SERVICES_LINK"
                            >Services Document</a> - to see who we are, what we offer and how we get paid.
                        </li>
                    </ul>
                </p>
                <p class="font-weight-bold pt-1">
                    Confused about your options?
                </p>
                <p>
                    Annuity Ready do not provide advice. If you would like guidance, please book an appointment with <a
                        :href="LINKS.PENSION_WISE_LINK"
                        target="_blank"
                    >Pension Wise</a>, the government's free, impartial pension guidance service (or call us to book
                    it for you). Or visit <a
                        :href="LINKS.MONEY_HELPER_LINK"
                        target="_blank"
                    >MoneyHelper</a> to find out where to get advice.
                </p>
            </div>
        </div>
    </div>
</template>
